/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step4_RuleInputs */

const en_dr_step4_rule = /** @type {(inputs: Dr_Step4_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nominal writing beats electronic brainstorming — write first, look later`)
};

const id_dr_step4_rule = /** @type {(inputs: Dr_Step4_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menulis sendiri dulu lebih efektif daripada brainstorming elektronik — tulis dulu, baru lihat`)
};

/**
* | output |
* | --- |
* | "Nominal writing beats electronic brainstorming — write first, look later" |
*
* @param {Dr_Step4_RuleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step4_rule = /** @type {((inputs?: Dr_Step4_RuleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step4_RuleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step4_rule(inputs)
	return en_dr_step4_rule(inputs)
});